module.exports = __webpack_public_path__ + "static/media/Muli-Black.b474a24a.ttf";